// extracted by mini-css-extract-plugin
module.exports = {"root":"fourth_root__1ofu8","check":"fourth_check__2oKbN"};